import { createContext } from 'react';
import { Select } from './types';

export interface SelectFigurantContextData {
  select: Select;
  setSelect: React.Dispatch<React.SetStateAction<Select>>;
}

export const SelectFigurantContext = createContext<SelectFigurantContextData | undefined>(undefined);
